var bookshelf = require("../index");

module.exports = bookshelf.model("SyncDesktopTable", {
  tableName: "sync_desktop_table",
});
